import { KeyTextField } from '@prismicio/client';
import styles from './InfoPopup.module.scss';

const Icon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      className={styles.icon}
    >
      <path
        d="M7.96827 5.32615C7.78139 5.32615 7.62326 5.26146 7.49387 5.13208C7.36449 5.0027 7.2998 4.84457 7.2998 4.65768C7.2998 4.4708 7.36449 4.31626 7.49387 4.19407C7.62326 4.06469 7.78139 4 7.96827 4C8.15515 4 8.30969 4.06469 8.43188 4.19407C8.56126 4.31626 8.62595 4.4708 8.62595 4.65768C8.62595 4.84457 8.56126 5.0027 8.43188 5.13208C8.30969 5.26146 8.15515 5.32615 7.96827 5.32615ZM8.41032 12H7.51544V6.28572H8.41032V12Z"
        fill="#609399"
      />
      <circle cx="8" cy="8" r="7.5" stroke="#609399" />
    </svg>
  );
};

interface Props {
  data: { title: KeyTextField; description: KeyTextField };
  variant: 'phone' | 'ssn';
}

const InfoPopup = ({ data, variant }: Props) => {
  return (
    <div className={`${styles.wrapper} ${styles[variant]}`}>
      <Icon />
      <div className={`${styles.textWrapper} ${styles[variant]}`}>
        <p className={styles.title}>{data.title}</p>
        <p className={styles.desc}>{data.description}</p>
      </div>
    </div>
  );
};

export default InfoPopup;
